import { render, staticRenderFns } from "./PostSocialRegistration.vue?vue&type=template&id=08aaccaa&"
import script from "./PostSocialRegistration.vue?vue&type=script&lang=js&"
export * from "./PostSocialRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PostSocialRegistration.vue?vue&type=style&index=0&id=08aaccaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports